import { PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../AppContext/AppContext';
import { AppRoute } from '../../constants';
import { useOrderFlowNavigation } from '../../hooks/useOrderFlowNavigation';
import { useOfferContext } from '../../OfferContext/OfferContext';
import { OrderFlow } from '../../types';

const { energyDynamic, energyFix, batteryOptimization } = OrderFlow;

/**
 * DataSafeguard component ensures that the user has valid data
 * per flow before the children components are rendered.
 */
export const DataSafeguard = ({ children }: PropsWithChildren) => {
  const { orderFlow, formValues, user } = useAppContext();
  const { offer } = useOfferContext();
  const { navigatePrevious } = useOrderFlowNavigation();
  const navigate = useNavigate();

  useEffect(() => {
    if ([energyFix, energyDynamic, batteryOptimization].includes(orderFlow!) && !offer)
      navigate(AppRoute.ROOT);
    if (orderFlow === batteryOptimization && !formValues.confirmedDynamicTariff && navigatePrevious)
      navigatePrevious();
    if (!orderFlow) navigate(AppRoute.ROOT);
  }, [orderFlow, offer, navigate, user]);

  return children;
};
